// extracted by mini-css-extract-plugin
export var closeButton = "_gk-2";
export var closeButtonIcon = "_gk-3";
export var lightboxContent = "_gk-1";
export var lightboxOverlay = "_gk-0";